import { useInfiniteQuery } from "@tanstack/react-query";
import { PatientTableDto, PatientTableFilters } from "../../../api-client";
import { useApi } from "../../../api/ApiProvider";
import { patientKeys } from "../../../stores/Patients";
import moment from "moment";
import { useDebouncedValue } from "../../../utils/useDebounce";
import { useEffect } from "react";
interface UsePatientsOptions {
  filters?: PatientTableFilters;
  enabled?: boolean;
}

export const useInfinitePatientsTable = ({
  filters = {},
  enabled = true,
}: UsePatientsOptions = {}) => {
  const { patients: patientsApi } = useApi();
  const limit = filters.limit ?? 50;

  const debouncedQuery = useDebouncedValue(filters.lastName || undefined);
  const filtersForAPI = { ...filters, lastName: debouncedQuery };

  const filtersWithoutSearch = { ...filters, lastName: undefined };

  const query = useInfiniteQuery<PatientTableDto[], Error>({
    queryKey: patientKeys.allPatientsTable.filtered(filtersWithoutSearch),
    queryFn: async ({ pageParam = 1 }) =>
      patientsApi.getFilteredAllPatients({ ...filtersForAPI, page: pageParam as number, limit }),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.length >= limit ? allPages.length + 1 : undefined,
    initialPageParam: 1,
    staleTime: moment.duration(1, "hour").asMilliseconds(),
    enabled,
    meta: { errorMessage: "Patientenliste konnte nicht geladen werden" },
  });

  // Refetch when debounced query changes
  // useEffect(() => {
  //   query.refetch({ cancelRefetch: true });
  // }, [debouncedQuery]); // refetch is stable
  useEffect(() => {
  if (enabled) {
    query.refetch({ cancelRefetch: true });
  }
}, [debouncedQuery, enabled]);


  return query;
};
